/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useContext } from 'react';

import { FormattedMessage } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import Lozenge from '@atlaskit/lozenge';
import { Text } from '@atlaskit/primitives/compiled';

import type { InvitedAppShortcutAllowedApsKey } from '../../../../common/types';
import { messages } from '../../../../common/ui/invited-app-shortcuts/messages';
import { InvitedAppShortcutsContext } from '../../../../controllers/invited-app-shortcuts-context';

import AnimatedLozenge from './animated-lozenge';

interface InvitedAppShortcutLabelProps {
	apsKey: InvitedAppShortcutAllowedApsKey;
	label: string;
}

const styles = cssMap({
	container: {
		display: 'grid',
		gridTemplateColumns: 'auto 1fr',
		alignItems: 'center',
		width: '100%',
	},
	lozengeContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		minWidth: '0px',
	},
});

export const InvitedAppShortcutLabel = ({ label, apsKey }: InvitedAppShortcutLabelProps) => {
	const { impressedProducts } = useContext(InvitedAppShortcutsContext);
	const hasAlreadySeenThisInvitedAppShortcut = impressedProducts[apsKey];

	return (
		<div css={styles.container}>
			<Text>{label}</Text>
			<div css={styles.lozengeContainer}>
				{hasAlreadySeenThisInvitedAppShortcut ? (
					<Lozenge appearance="inprogress">
						<FormattedMessage {...messages.invitedLozenge} />
					</Lozenge>
				) : (
					<AnimatedLozenge appearance="new">
						<FormattedMessage {...messages.invitedLozenge} />
					</AnimatedLozenge>
				)}
			</div>
		</div>
	);
};
